module.exports = __webpack_public_path__ + "static/media/rs.eb3be364.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/rs.svg
// module id = 1340
// module chunks = 0